module.exports = __webpack_public_path__ + "static/media/logo-fs.5a403c72.png";